import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuthContext } from '../../../hooks/useAuthContext';


const MoveToInv = (props) => {
    const [listPrice, setListPrice] = useState(0);
    const [error, setError] = useState(null);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    const navigate = useNavigate();

    const moveToInv = 'true';

    const handleSubmit = async (event) => {
        event.preventDefault();

        const id = props.watchId;
        const inventory = {moveToInv, listPrice};
        try {
            const response = await axios.patch(
                process.env.REACT_APP_SERVER_URL + '/api/inventory/editInventory/' + id, 
                inventory,
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            console.log('Added to inventory: ' + response.data);
        } catch (e) {
            console.log(e.response.data.error);
            setError(e.response.data.error);
        }

        navigate('/main/home');
    }
    
    return(
        <form className='modal-form' onSubmit={user ? handleSubmit : null}>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">List Price</label>
                    <input 
                        type="number"
                        className="form-control"
                        onChange={(event) => setListPrice(event.target.value)}
                        value={listPrice}    
                    />
                </div>
            </div>

            <button type="submit" className="btn btn-light">Move To Inventory</button>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default MoveToInv; 